const links = [
  {
    title: "What we buy",
    links: [
      {
        title: "Luxury watches ",
        link: "/what-we-buy/watch-buyers-nyc",
        subLinks: [
          {
            title: "Sell watch Midtown East",
            link: "/what-we-buy/watch-buyers-nyc/where-to-sell-watch-midtown-east",
          },
          {
            title: "Sell watch Upper East Side",
            link: "/what-we-buy/watch-buyers-nyc/where-to-sell-watch-upper-east-side",
          },
          {
            title: "Sell watch Tribeca",
            link: "/what-we-buy/watch-buyers-nyc/where-to-sell-watch-tribeca",
          },
          {
            title: "Sell watch Financial District",
            link: "/what-we-buy/watch-buyers-nyc/where-to-sell-watch-financial-district",
          },
          {
            title: "Sell watch Chelsea",
            link: "/what-we-buy/watch-buyers-nyc/where-to-sell-watch-chelsea",
          },
          {
            title: "Sell watch Soho",
            link: "/what-we-buy/watch-buyers-nyc/where-to-sell-watch-soho",
          },
          {
            title: "Sell Rolex Midtown East",
            link: "/what-we-buy/watch-buyers-nyc/sell-rolex-midtown-east",
          },
          {
            title: "Sell Rolex Upper East Side",
            link: "/what-we-buy/watch-buyers-nyc/sell-rolex-upper-east-side",
          },
          {
            title: "Sell Rolex Tribeca",
            link: "/what-we-buy/watch-buyers-nyc/sell-rolex-tribeca",
          },
          {
            title: "Sell Rolex Financial District",
            link: "/what-we-buy/watch-buyers-nyc/sell-rolex-financial-district",
          },
          {
            title: "Sell Rolex Chelsea",
            link: "/what-we-buy/watch-buyers-nyc/sell-rolex-chelsea",
          },
          {
            title: "Sell Rolex Soho",
            link: "/what-we-buy/watch-buyers-nyc/sell-rolex-soho",
          },
          {
            title: "Sell Rolex Flatiron District",
            link: "/what-we-buy/watch-buyers-nyc/sell-rolex-flatiron-district",
          },
          {
            title: "Sell Rolex West Village",
            link: "/what-we-buy/watch-buyers-nyc/sell-rolex-flatiron-west-village",
          },
          {
            title: "Sell Rolex Nomad",
            link: "/what-we-buy/watch-buyers-nyc/sell-rolex-nomad",
          },
          {
            title: "Sell Rolex Upper West Side",
            link: "/what-we-buy/watch-buyers-nyc/sell-rolex-upper-west-side",
          },
           {
            title: "Sell Rolex Murray Hill",
            link: "/what-we-buy/watch-buyers-nyc/sell-rolex-murray-hill",
          },
          {
            title: "Sell Rolex Gramercy",
            link: "/what-we-buy/watch-buyers-nyc/sell-rolex-gramercy",
          },
          {
            title: "Sell Rolex Hudson Yards",
            link: "/what-we-buy/watch-buyers-nyc/sell-rolex-hudson-yards",
          },
          {
            title: "Sell Rolex Dumbo",
            link: "/what-we-buy/watch-buyers-nyc/sell-rolex-dumbo",
          },
           {
            title: "Sell Rolex Lincoln Square",
            link: "/what-we-buy/watch-buyers-nyc/sell-rolex-lincoln-square",
          },
          {
            title: "Sell Rolex Brooklyn Heights",
            link: "/what-we-buy/watch-buyers-nyc/sell-rolex-brooklyn-heights",
          },
          {
            title: "Sell Rolex Park Slope",
            link: "/what-we-buy/watch-buyers-nyc/sell-rolex-park-slope",
          },
          {
            title: "Sell Rolex Long Island City",
            link: "/what-we-buy/watch-buyers-nyc/sell-rolex-long-island-city",
          },
          {
            title: "Sell Rolex Hoboken",
            link: "/what-we-buy/watch-buyers-nyc/sell-rolex-hoboken",
          },
          {
            title: "Sell Rolex Downtown Jersey City",
            link: "/what-we-buy/watch-buyers-nyc/sell-rolex-downtown-jersey-city",
          },
        ],
      },
      {
        title: "Diamonds",
        link: "/what-we-buy/sell-diamonds-nyc",
        subLinks: [
          {
            title: "Diamond Buyers Midtown East",
            link: "/what-we-buy/sell-diamonds-nyc/diamond-buyers-midtown-east",
          },
          {
            title: "Diamond Buyers Upper East Side",
            link: "/what-we-buy/sell-diamonds-nyc/diamond-buyers-upper-east-side",
          },
          {
            title: "Diamond Buyers Tribeca",
            link: "/what-we-buy/sell-diamonds-nyc/diamond-buyers-tribeca",
          },
          {
            title: "Diamond Buyers Financial District",
            link: "/what-we-buy/sell-diamonds-nyc/diamond-buyers-financial-district",
          },
          {
            title: "Diamond Buyers Chelsea",
            link: "/what-we-buy/sell-diamonds-nyc/diamond-buyers-chelsea",
          },
          {
            title: "Diamond Buyers Soho",
            link: "/what-we-buy/sell-diamonds-nyc/diamond-buyers-soho",
          },
        ],
      },
      {
        title: "Gold",
        link: "/what-we-buy/gold-buyers-nyc",
      },
      {
        title: "Gold Coins",
        link: "/what-we-buy/gold-coin-buyers-nyc",
      },
      {
        title: "Jewelry",
        link: "/what-we-buy/jewelry-buyers",
      },
      {
        title: "Silver",
        link: "/what-we-buy/silver-buyers",
      },
      {
        title: "Platinum",
        link: "/what-we-buy/platinum-buyers",
        subLinks: [
          {
            title: "Sell platinum ring",
            link: "/what-we-buy/platinum-buyers/sell-platinum-ring",
          },
        ],
      },
      {
        title: "Engagement rings",
        link: "/what-we-buy/engagement-ring-buyers",
      },
    ],
  },
  {
    title: "Other",
    links: [
      {
        title: "Collateral loans",
        link: "/collateral-loans",
      },
      {
        title: "Bridge loans",
        link: "/bridge-loans",
      },
      {
        title: "Blogs",
        link: "/blogs",
      },
    ],
  },
  {
    title: "Company",
    links: [
      {
        title: "Reviews",
        link: "/customer-reviews",
      },
      {
        title: "About us",
        link: "/about-us",
      },
      {
        title: "Media and News",
        link: "/media-coverage",
      },
      {
        title: "Get A Loan",
        link: "/get-a-loan",
      },
      {
        title: "Contact us",
        link: "/contact-us",
      },
    ],
  },
];

export default links;
